import React from 'react';
import createReactClass from 'create-react-class';
import auth0 from '../helpers/auth0';

const LoginInProcess = createReactClass({
  componentDidMount() {
    var isAuthenticated = auth0.isAuthenticated();

    if(!isAuthenticated) {
      auth0.lock.show();
    }
  },

  render() {
    return (
      <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', alignContent: 'center', height: '500px'}}>
        <img src="/images/logo.png" alt="Lagerverwaltung" width="146" height="52"/>
        <h2>Einen Moment Geduld bitte, während wir Sie anmelden...</h2>
      </div>
    );
  }

});

export default LoginInProcess;



// WEBPACK FOOTER //
// ./src/components/LoginInProcess.js